// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type MoneyBackGuarantee20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const MoneyBackGuarantee20: FC<MoneyBackGuarantee20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M3.5 7h13V5.5h-13V7ZM2 5.5c0-.403.15-.753.448-1.052A1.44 1.44 0 0 1 3.5 4h13c.403 0 .753.15 1.052.448.299.299.448.65.448 1.052V10H3.5v4.5H7V16H3.5a1.557 1.557 0 0 1-1.052-.448A1.39 1.39 0 0 1 2 14.506V5.5ZM12.333 18l-3.52-3.542 1.062-1.062 2.458 2.479 4.604-4.604L18 12.333 12.333 18ZM3.5 5.5v9-3.146 2.23V5.5Z" />
        </svg>
    );
};

export default MoneyBackGuarantee20;
